import Subtitle from "@/components/Subtitle";
import Title from "@/components/Title";
import BasicText from "@/components/BasicText";

import Image from "@/components/Image";
import backgroundEllipse from "@/assets/images/tokenomics-background-circle.svg";
import innerCircle from "@/assets/images/tokenomics-circle.svg";
import logo from "@/assets/images/tokenomics-logo.svg";

import TokenomicsComponent from "@/components/pages/node/TokenomicsComponent";

import link1 from "@/assets/images/tokenomics-link-1.svg";
import link2 from "@/assets/images/tokenomics-link-2.svg";
import link3 from "@/assets/images/tokenomics-link-3.svg";
import link4 from "@/assets/images/tokenomics-link-4.svg";
import link5 from "@/assets/images/tokenomics-link-5.svg";
import link6 from "@/assets/images/tokenomics-link-6.svg";
import link7 from "@/assets/images/tokenomics-link-7.svg";
import link8 from "@/assets/images/tokenomics-link-8.svg";

const Tokenomics: React.FC = () => {
  const elements = [
    { title: "Strategic Size", percent: 1.9 },
    { title: "Foundation", percent: 10.5 },
    { title: "Validator Sale", percent: 5.2 },
    { title: "Team", percent: 12.8 },
    { title: "Seed Sale", percent: 16.2 },
    { title: "Founding Sale", percent: 12.9 },
    { title: "Coinlist Sale", percent: 1.6 },
    { title: "Community", percent: 38.9 },
  ];

  return (
    <div className="flex flex-col items-center md:p-20 gap-10 min-h-screen">
      <div className="flex flex-col text-center">
        <Subtitle>// Tokenomics</Subtitle>
        <Title className="mt-4">Our Tokenomics</Title>
        <BasicText className="mt-2" size="18px" color="faded">Meet Our team</BasicText>
      </div>

      <div className="hidden lg:flex items-center justify-center relative my-[240px] w-[1055px]">
        <Image
          src={backgroundEllipse}
          alt="ellipse"
          className="absolute w-[320px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
        />
        <Image
          src={innerCircle}
          alt="ellipse"
          className="absolute w-[400px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
        />
        <Image
          src={logo}
          alt="ellipse"
          className="absolute w-[80px] top-1/2 left-1/2 transform -translate-x-1/2 -translate-y-1/2"
        />

        <div className="absolute left-[240px] top-[-130px]">
          <Image src={link1} alt=''></Image>
        </div>

        <TokenomicsComponent
          title={elements[0].title}
          percent={elements[0].percent}
          className="left-[200px] top-[-230px]"
        />

        <div className="absolute left-[160px] top-[-70px]">
          <Image src={link2} alt=''></Image>
        </div>

        <TokenomicsComponent
          title={elements[1].title}
          percent={elements[1].percent}
          className="left-[-40px] top-[-150px]"
        />

        <div className="absolute left-[195px] top-[20px]">
          <Image src={link3} alt=''></Image>
        </div>

        <TokenomicsComponent
          title={elements[2].title}
          percent={elements[2].percent}
          className="left-[-5px] top-[-20px]"
        />

        <div className="absolute left-[340px] top-[150px]">
          <Image src={link4} alt=''></Image>
        </div>

        <TokenomicsComponent
          title={elements[3].title}
          percent={elements[3].percent}
          className="left-[140px] top-[120px]"
        />

        <div className="absolute right-[280px] top-[-155px]">
          <Image src={link5} alt=''></Image>
        </div>

        <TokenomicsComponent
          title={elements[4].title}
          percent={elements[4].percent}
          className="right-[80px] top-[-220px]"
        />

        <div className="absolute right-[175px] top-[-70px]">
          <Image src={link6} alt=''></Image>
        </div>

        <TokenomicsComponent
          title={elements[5].title}
          percent={elements[5].percent}
          className="right-[-25px] top-[-110px]"
        />

        <div className="absolute right-[175px] top-[40px]">
          <Image src={link7} alt=''></Image>
        </div>

        <TokenomicsComponent
          title={elements[6].title}
          percent={elements[6].percent}
          className="right-[-25px] top-[0px]"
        />

        <div className="absolute right-[330px] top-[130px]">
          <Image src={link8} alt=''></Image>
        </div>

        <TokenomicsComponent
          title={elements[7].title}
          percent={elements[7].percent}
          className="right-[130px] top-[110px]"
        />
      </div>

      <div className="flex flex-wrap lg:hidden items-center justify-center m-5">
        {elements.map((element) => {
          return (
            <TokenomicsComponent
              title={element.title}
              percent={element.percent}
              className="relative m-2"
            />
          );
        })}
      </div>
    </div>
  );
};

export default Tokenomics;
